
export const formattedDate = (datetime?: Date) => {
    if (datetime === undefined) return ''
    return datetime.toString().replace(/^(\d{4})-(\d{2})-(\d{2}).*$/, '$3.$2.$1');
}


export const formattedDateTime = (datetime?: Date) => {
    if (datetime === undefined) return ''

    if(!datetime.toString().match(/^(\d{4})-(\d{2})-(\d{2})T/)) {
        if( new Date(datetime).getFullYear()  === 1970) return '01.01.2024 00:00:00'
        return '01.01.2024 00:00:01'
    }
    return datetime.toString().replace(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}).*$/, '$3.$2.$1 $4:$5:$6');
}
